"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    duration: {
        short: 350
    }
};
//# sourceMappingURL=transitions.js.map